import { FormErrors } from "redux-form";

import { SuppInfoFormValues } from "./components/SuppInfoForm";
import * as constants from "./constants";

// Meant to be RFC 5322 compliant
const EMAIL_PATTERN = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
// https://github.com/datnq/Vietnamese-mobile-carrier + support for leading +84
const PHONE_PATTERN = /^(\+84|0)(1[2689]|9)[0-9]{8}$/;

// Select options not checked for changes; not important on client, leave to server
function validate(formValues: SuppInfoFormValues) {
  const errors: FormErrors<SuppInfoFormValues> = {};

  const genRequiredMsg = () => "Cần thiết";

  // Validate assoc payment_upfront_rate select val (if radio set to true)
  if (
    formValues.has_payment_upfront &&
    formValues.has_payment_upfront === "true" &&
    formValues.payment_upfront_rate &&
    !constants.PAYMENT_UPFRONT_OPTIONS
      .map(opt => opt.value)
      .includes(formValues.payment_upfront_rate)
  ) {
    errors.payment_upfront_rate = genRequiredMsg();
  }

  // Validate all customer details
  if (!formValues.customer_name_first) {
    errors.customer_name_first = genRequiredMsg();
  }

  if (!formValues.customer_name_last) {
    errors.customer_name_last = genRequiredMsg();
  }

  if (!formValues.customer_phone) {
    errors.customer_phone = genRequiredMsg();
  } else if (
    !PHONE_PATTERN.test(formValues.customer_phone.replace(/\s/g, ""))
  ) {
    errors.customer_phone = "SĐT không hợp lệ";
  }

  if (!formValues.customer_email) {
    errors.customer_email = genRequiredMsg();
  } else if (!EMAIL_PATTERN.test(formValues.customer_email)) {
    errors.customer_email = "Email không hợp lệ";
  }

  return errors;
}

export default validate;



// WEBPACK FOOTER //
// ./src/routes/Step5/supp-form-validation.ts